export default __webpack_public_path__ + "static/media/Logo.d38aaf59.svg";